export default "__VITE_ASSET__DkjMXaXD__"